import React from 'react';

import { StaticImage, StaticImages } from 'components/picture/static-image';

export const Animation = () => (
  <StaticImage
    role="img"
    alt="Burger King logo bouncing loader"
    source={StaticImages.BurgerBounceLoader}
    style={{ width: '68%' }}
  />
);
